import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";
import Button from "../../common_components/Button";
import Modal from "../../common_components/Modal";
import { DateTime } from 'luxon';
import BackIcon from "../../../../../../../assets/images/user_app/mission_page/back_button.svg";
import BackIconPNG from "../../../../../../../assets/images/user_app/mission_page/back_button.png";


import XIcon from "../../../../../../../assets/images/user_app/mission_page/x_icon.svg";

import { DayPicker } from "react-day-picker";
// import "react-day-picker/style.css"; This is imported in application.css instead.

import MissionEventAvailabilityAPI from "../../../api/api_calls/MissionEventAvailabilityAPI";



function ScheduleModal({ availabilities, lookAheadDays, startDate, endDate, timeZone, missionId, ...props }) {
    const [selected, setSelected] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const alert = useAlert();

    // Create DateTime from props
    const start = DateTime.fromISO(startDate, { zone: timeZone }).startOf('day');
    const end = start.plus({ days: lookAheadDays });

    // Calculate the available times for the selected date.
    // Format the selected date from a date to  yyyy-MM-dd
    const selectedDate = selected ? DateTime.fromJSDate(selected).toISODate() : null;
    const availableTimes = selectedDate ? availabilities.days.filter(day => day.date === selectedDate)[0].appointments : [];

    const selectedAppointmentString = selectedTime ? DateTime.fromJSDate(selected).toFormat('cccc, LLL d') + " at " + selectedTime.start_time_text : "";

    // Build a Set of enabled ISO date strings ('yyyy-MM-dd') for fast lookup
    const enabledDateSet = new Set(
        availabilities.days.map(d =>
            DateTime.fromISO(d.date, { zone: timeZone }).toISODate() // -> 'YYYY-MM-DD'
        )
    );

    // Disable function: DayPicker passes a JS Date in local time (user's machine).
    // Use the calendar date (year/month/day) and interpret it in the mission's timezone
    // so we don't shift the day when converting (e.g. CET midnight → previous day in EST).
    const isDateDisabled = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const dt = DateTime.fromObject({ year, month, day }, { zone: timeZone }).startOf('day');
        return (
            dt < start ||
            dt > end ||
            !enabledDateSet.has(dt.toISODate())
        );
    };


    function selectDate(date) {
        setSelected(date);
        setSelectedTime(null);
        console.log(date);
    }

    function selectTime(time) {
        setSelectedTime(time);
        console.log(time);
    }

    function handleSubmit(event) {
        event.preventDefault();
        console.log("selectedDate", selected);
        console.log("selectedTime", selectedTime);

        async function submitAppointment() {
            const response = await MissionEventAvailabilityAPI.claim(missionId, selectedTime.mission_event_availability_id, navigate)

            if (response.success) {
                alert.show("Your interview has been scheduled. You'll receive a calendar invite in your email shortly.", { type: 'success' })
                props.refreshMissionStatus();
                props.toggleModal();
            } else {
                if (response.error) {
                    alert.show(response.error, { type: 'error' })
                } else {
                    alert.show("Unable to submit. Try again later", { type: 'error' })
                }
            }
            setSubmitting(false)
        }

        if (submitting) return;
        setSubmitting(true)
        submitAppointment();
    }

    function closeModalAndClearSelection() {
        setSelected(null);
        setSelectedTime(null);
        props.toggleModal();
    }

    return (
        <Modal toggleModal={props.toggleModal} isOpen={props.isOpen} closeable={true} backgroundColor="dark">
            <div className="schedule-modal-card desktop-version">
                <form className="schedule-modal-card-form" onSubmit={handleSubmit}>
                    <div className="schedule-modal-card-input-container">
                        <div className="schedule-modal-card-calendar-container">
                            <DayPicker
                                mode="single"
                                selected={selected}
                                onSelect={selectDate}
                                disabled={isDateDisabled}
                                startMonth={start}
                                endMonth={end}
                            />
                            <div className="schedule-modal-card-timezone-note">
                                Timezone: {timeZone}
                            </div>
                        </div>
                        <TimePicker
                            selectedDateinJS={selected}
                            selectedDate={selectedDate}
                            availableTimes={availableTimes}
                            selectedAppointment={selectedTime}
                            onSelect={selectTime}

                        />
                    </div>
                    <div className="schedule-modal-card-button-container">
                        <Button color="gray" size="small" onClick={closeModalAndClearSelection} >Cancel</Button>
                        <div className="schedule-modal-selected-time-text">
                            {selectedAppointmentString}
                        </div>
                        <Button color="primary" size="medium" type="submit" disabled={!selectedAppointmentString}>Schedule</Button>
                    </div>
                </form>
            </div>
            {/* Mobile version */}
            <div className="schedule-modal-card mobile-version">
                <form className="schedule-modal-card-form" onSubmit={handleSubmit}>
                    {!selected ?
                        <>
                            <div className="schedule-modal-card-input-container">

                                <div className="schedule-modal-card-calendar-container">
                                    <DayPicker
                                        mode="single"
                                        selected={selected}
                                        onSelect={selectDate}
                                        disabled={isDateDisabled}
                                        startMonth={start}
                                        endMonth={end}
                                    />
                                    <div className="schedule-modal-card-timezone-note">
                                        Timezone: {timeZone}
                                    </div>
                                </div>
                            </div>
                            <div className="schedule-modal-card-button-container">
                                <Button color="gray" size="medium" fullWidth={true} type="button" onClick={closeModalAndClearSelection} >Cancel</Button>
                            </div>
                        </>
                        :
                        <>
                            <TimePicker
                                selectedDateinJS={selected}
                                selectedDate={selectedDate}
                                availableTimes={availableTimes}
                                selectedAppointment={selectedTime}
                                onSelect={selectTime}
                                onClickBackButton={() => setSelected(null)}
                                onClickCloseButton={closeModalAndClearSelection}

                            />
                            <div className="schedule-modal-card-button-container">
                                <div className="schedule-modal-selected-time-text">
                                    {selectedAppointmentString}
                                </div>
                                <Button color="primary" size="medium" type="submit" fullWidth={true} disabled={!selectedAppointmentString}>Schedule</Button>
                            </div>
                        </>
                    }

                </form>
            </div>
        </Modal>
    )

}

function TimePicker({ selectedDateinJS, selectedDate, availableTimes, selectedAppointment, onSelect, onClickBackButton = () => { }, onClickCloseButton = () => { }, closeModalAndClearSelection = () => { } }) {
    console.log("selectedDate", selectedDate);
    console.log("availableTimes", availableTimes);

    // Convert to DayOfWeek, MONTH day.
    // E.g. "Tuesday, April 16"
    const selectedDateString = selectedDate ? DateTime.fromJSDate(selectedDateinJS).toFormat('cccc, LLL d') : "Select a date";

    return (
        <div className="time-picker-container">
            <div className="time-picker-header mobile-version">
                <button className="time-picker-back-button" onClick={() => onClickBackButton()}>
                    <img src={BackIcon} alt="Back" />
                </button>
                <h4 className="time-picker-header-text-mobile">{selectedDateString}</h4>
                <button className="time-picker-x-button" onClick={() => onClickCloseButton()}>
                    <img src={XIcon} alt="Close" />
                </button>
            </div>
            <div className="time-picker-header desktop-version">
                {selectedDateString}
            </div>
            <div className="time-picker-divider" />
            <div className="time-picker-container-wrapper">
                <div className="time-picker-times-container">
                    {availableTimes.length > 0 ? (
                        availableTimes.map(appointment => (
                            <button type="button" className={`time-picker-time ${selectedAppointment?.mission_event_availability_id === appointment.mission_event_availability_id ? 'selected' : ''}`} key={appointment.mission_event_availability_id} onClick={() => onSelect(appointment)}>
                                {appointment.start_time_text}
                            </button>
                        ))
                    ) : (
                        <div className="time-picker-no-times">
                        </div>
                    )}
                </div>
                {availableTimes.length > 8 && <div className="time-picker-fade-bottom"></div>}
            </div>
        </div>

    )
}

export default ScheduleModal;